if (!customElements.get('wls-hero-5050')) {
    class WlsHero5050Swiper extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                swiper: 'swiper',
                wrapper: 'swiper-wrapper',
                slide: 'swiper-slide',
                pagination: 'js-wls-hero-5050-swiper-pagination'
            };

            this.elements = {
                slider: null,
                wrapper: null,
                slides: null,
                pagination: null
            };
        }

        connectedCallback() {
            this.initElements();
            this.init();
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

        initElements() {
            // Find the .swiper element inside the custom element (parent)
            this.elements.slider = this.querySelector(`.${this.classes.swiper}`);
            this.elements.wrapper = this.querySelector(`.${this.classes.wrapper}`);
            this.elements.slides = this.querySelectorAll(`.${this.classes.slide}`);
            this.elements.pagination = this.querySelector(`.${this.classes.pagination}`);
        }

        init() {
            if (!this.elements.slider) {
                return;
            }
            if (!this.elements.slides || this.elements.slides.length === 0) {
                return;
            }
            this.initializeSwiper();
        }

        initializeSwiper() {
            // Check if Swiper is available
            if (typeof Swiper === 'undefined') {
                return;
            }

            // Read autoplay delay from data attribute
            const autoplayDelay = this.dataset.swiperAutoplay;
            const autoplayConfig = autoplayDelay && parseInt(autoplayDelay) > 0 
                ? { delay: parseInt(autoplayDelay) } 
                : false;
            
            try {
                this.swiper = new Swiper(this.elements.slider, {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 16,
                    pagination: {
                        el: this.elements.pagination,
                        clickable: true,
                    },
                    autoplay: autoplayConfig,
                });
            } catch (error) {
                // Swiper initialization failed
            }
        }
    }

    customElements.define('wls-hero-5050', WlsHero5050Swiper);
}